<template>

  <svg viewBox="0 0 24 24" role="presentation" focusable="false" width="25" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M11.36 12.9a9 9 0 00-8.966 8.206 1 1 0 101.992.175 7 7 0 018.2-6.274 1 1 0 10.347-1.97 9.051 9.051 0 00-1.574-.137zm6.428 1.121a1 1 0 00-1.414-.043l-3.45 3.243a1 1 0 000 1.458l3.45 3.243a1 1 0 101.37-1.457l-1.611-1.515h5.276a1 1 0 100-2h-5.276l1.611-1.515a1 1 0 00.044-1.414zM8.359 7a3 3 0 116 0 3 3 0 01-6 0zm-2 0a5 5 0 1010 0 5 5 0 00-10 0z"/></svg>

</template>


<script>

  export default {"name":"icon-107355e9384a95dfa371d20902201fe1"}

</script>